// Display copy only; protocol values and user data are not translated.
export default {
  "{v0} step(s) configured": "Pasos configurados: {v0}",
  "Something went wrong with the API Testing interface": "Ocurrió un error en la interfaz de pruebas de API",
  "Please refresh the page to continue. If the problem persists, please contact support.": "Actualiza la página para continuar. Si el problema persiste, contacta con soporte.",
  "Refresh Page": "Actualizar página",
  "Server returned HTML instead of JSON. Please check your API endpoint.": "El servidor devolvió HTML en lugar de JSON. Revisa el endpoint de tu API.",
  "Server error - please check your connection and try again": "Error del servidor: revisa tu conexión e inténtalo de nuevo",
  "Please provide a chain name and add at least one step": "Ingresa un nombre para la cadena y agrega al menos un paso",
  "Request already in progress, please wait...": "La solicitud ya está en curso. Espera un momento...",
  "Chain updated successfully": "Cadena actualizada correctamente",
  "Chain created successfully": "Cadena creada correctamente",
  "Failed to save chain": "No se pudo guardar la cadena",
  "Chain deleted successfully": "Cadena eliminada correctamente",
  "Failed to delete chain": "No se pudo eliminar la cadena",
  "This chain is already running, please wait...": "Esta cadena ya se está ejecutando. Espera un momento...",
  "Another chain is currently running, please wait...": "Ya hay otra cadena en ejecución. Espera un momento...",
  "Chain executed successfully! All {v0} steps passed.": "¡Cadena ejecutada correctamente! Los {v0} pasos se completaron con éxito.",
  "Chain partially completed. {v0}/{v1} steps passed.": "Cadena completada parcialmente. {v0} de {v1} pasos completados con éxito.",
  "Chain execution failed. {v0} step(s) failed.": "La ejecución de la cadena falló. {v0} paso(s) fallidos.",
  "Failed to execute chain": "No se pudo ejecutar la cadena",
  "To create Jira tickets, please configure a Jira integration in the Integrations tab first.": "Para crear incidencias en Jira, configura primero una integración de Jira en la sección Integraciones.",
  "Failed to create Jira ticket: {v0}": "No se pudo crear la incidencia en Jira: {v0}",
  "Please select a file to upload": "Selecciona un archivo para cargar",
  "Failed to import file": "No se pudo importar el archivo",
  "Please enter a test description": "Ingresa una descripción de la prueba",
  "AI test generated successfully!": "¡Prueba generada con IA correctamente!",
  "Monthly test generation limit reached. Please upgrade your plan.": "Alcanzaste el límite mensual de generación de pruebas. Mejora tu plan.",
  "Failed to generate test. Please try again.": "No se pudo generar la prueba. Inténtalo de nuevo.",
  "Failed to save test. Please try again.": "No se pudo guardar la prueba. Inténtalo de nuevo.",
  "Failed to execute test. Please check your configuration.": "No se pudo ejecutar la prueba. Revisa su configuración.",
  "Please select a date and time for the scheduled execution": "Selecciona la fecha y la hora de la ejecución programada",
  "Please select a start date and time for recurring execution": "Selecciona la fecha y la hora de inicio de la ejecución recurrente",
  "Schedule created successfully!": "¡Programación creada correctamente!",
  "Failed to create schedule": "No se pudo crear la programación",
  "Failed to toggle schedule status": "No se pudo cambiar el estado de la programación",
  "Schedule deleted successfully": "Programación eliminada correctamente",
  "Failed to delete schedule": "No se pudo eliminar la programación",
  "Invalid JSON format in Variables field. Please check your syntax.": "El JSON del campo Variables no es válido. Revisa la sintaxis.",
  "Failed to create environment:": "No se pudo crear el entorno:",
  "Failed to create environment.": "No se pudo crear el entorno.",
  "Please fill in all OAuth2 fields (Token URL, Client ID, Client Secret)": "Completa todos los campos de OAuth2 (URL del token, ID del cliente y secreto del cliente)",
  "Please enter credential value": "Ingresa el valor de la credencial",
  "Credential saved successfully": "Credencial guardada correctamente",
  "Failed to save credential.": "No se pudo guardar la credencial.",
  "Environment deleted successfully": "Entorno eliminado correctamente",
  "Failed to delete environment.": "No se pudo eliminar el entorno.",
  "Credential deleted successfully": "Credencial eliminada correctamente",
  "Failed to delete credential.": "No se pudo eliminar la credencial.",
  "API test deleted successfully": "Prueba de API eliminada correctamente",
  "Failed to delete API test.": "No se pudo eliminar la prueba de API.",
  "Failed to update environment.": "No se pudo actualizar el entorno.",
  "API Testing": "Pruebas de API",
  "Create and execute API tests with AI-powered generation": "Crea y ejecuta pruebas de API con generación asistida por IA",
  "AI Generate": "Generar con IA",
  "Generate API Test with AI": "Generar prueba de API con IA",
  "Describe your API endpoint and let AI generate the test for you.": "Describe el endpoint de tu API y deja que la IA genere la prueba.",
  "Describe your API test": "Describe tu prueba de API",
  "E.g., 'Test GET /api/users returns 200 with user list containing id, name, email fields'": "Por ejemplo: 'Probar que GET /api/users devuelve 200 y una lista de usuarios con los campos id, name y email'",
  "Environment (Optional)": "Entorno (opcional)",
  "Select environment": "Selecciona un entorno",
  "Generating...": "Generando...",
  "Generate Test": "Generar prueba",
  "Tests": "Pruebas",
  "Chains": "Cadenas",
  "Schedules": "Programaciones",
  "Imports": "Importaciones",
  "Environments": "Entornos",
  "Credentials": "Credenciales",
  "History": "Historial",
  "API Tests": "Pruebas de API",
  "Search tests by name...": "Buscar pruebas por nombre...",
  "Project:": "Proyecto:",
  "All Projects": "Todos los proyectos",
  "Clear": "Limpiar",
  "Load More Tests": "Cargar más pruebas",
  "API Test Chains": "Cadenas de pruebas de API",
  "Create multi-step workflows that chain API tests with variable propagation": "Crea flujos de varios pasos que enlazan pruebas de API y comparten variables",
  "Create Chain": "Crear cadena",
  "No Chains Yet": "Aún no hay cadenas",
  "Create your first chain to link multiple API tests together. Variables extracted from one test can be automatically used in subsequent tests.": "Crea tu primera cadena para enlazar varias pruebas de API. Las variables extraídas de una prueba pueden utilizarse automáticamente en los siguientes pasos.",
  "Example workflow:": "Ejemplo de flujo:",
  "Create Your First Chain": "Crear mi primera cadena",
  "Edit Chain": "Editar cadena",
  "Create New Chain": "Crear nueva cadena",
  "Build a multi-step API workflow. Variables extracted from each step will be available in subsequent steps.": "Construye un flujo de API de varios pasos. Las variables extraídas en cada paso estarán disponibles en los siguientes.",
  "Add at least one step": "Agrega al menos un paso",
  "Cancel": "Cancelar",
  "Submitting...": "Enviando...",
  "Saving...": "Guardando...",
  "Update Chain": "Actualizar cadena",
  "Chain Execution Result": "Resultado de la ejecución de la cadena",
  "Loading schedules...": "Cargando programaciones...",
  "Test Schedules (": "Programaciones de pruebas (",
  "Refresh": "Actualizar",
  "One-time": "Una vez",
  "Pause": "Pausar",
  "Activate": "Activar",
  "Next Run:": "Próxima ejecución:",
  "Not scheduled": "Sin programar",
  "Executions:": "Ejecuciones:",
  "passed,": "aprobadas,",
  "failed": "fallida",
  "Last Execution:": "Última ejecución:",
  "Execution #": "Ejecución n.º",
  "No executions yet": "Aún no hay ejecuciones",
  "Total Runs:": "Ejecuciones totales:",
  "Success Rate:": "Tasa de éxito:",
  "Last Run:": "Última ejecución:",
  "{v0}m ago": "hace {v0} min",
  "{v0}h ago": "hace {v0} h",
  "{v0}d ago": "hace {v0} d",
  "Ends:": "Finaliza:",
  "Test Schedules": "Programaciones de pruebas",
  "Schedule Your API Tests": "Programa tus pruebas de API",
  "Set up automated test execution with flexible scheduling options": "Configura ejecuciones automáticas con opciones de programación flexibles",
  "One-time scheduled runs": "Ejecuciones programadas únicas",
  "Daily, weekly, monthly recurring": "Recurrencia diaria, semanal o mensual",
  "Email & in-app notifications": "Notificaciones por correo y en la aplicación",
  "Timezone support": "Compatibilidad con zonas horarias",
  "Click the \"Schedule\" button next to any test to get started": "Haz clic en el botón \"Programar\" de una prueba para comenzar",
  "API Collection Import": "Importación de colecciones de API",
  "Import Postman Collections or OpenAPI specifications": "Importa colecciones de Postman o especificaciones OpenAPI",
  "Import Collection": "Importar colección",
  "No imports yet": "Aún no hay importaciones",
  "Import your first API collection to get started": "Importa tu primera colección de API para comenzar",
  "Import History": "Historial de importaciones",
  "Tests Created": "Pruebas creadas",
  "Total Endpoints": "Endpoints totales",
  "Skipped": "Omitidos",
  "Add Environment": "Agregar entorno",
  "Create Environment": "Crear entorno",
  "Set up a new environment with custom variables and base URL.": "Configura un entorno nuevo con variables personalizadas y una URL base.",
  "Environment name (e.g., Development)": "Nombre del entorno (por ejemplo, Desarrollo)",
  "Description (optional)": "Descripción (opcional)",
  "Variables (JSON format)": "Variables (formato JSON)",
  "Enter valid JSON. Will be validated on save.": "Ingresa un JSON válido. Se validará al guardar.",
  "Creating...": "Creando...",
  "API Credentials": "Credenciales de API",
  "Add Credential": "Agregar credencial",
  "Create API Credential": "Crear credencial de API",
  "Add authentication credentials for your API endpoints.": "Agrega credenciales de autenticación para los endpoints de tu API.",
  "Credential name": "Nombre de la credencial",
  "Type": "Tipo",
  "Token URL (e.g., https://api.example.com/oauth/token)": "URL del token (por ejemplo, https://api.example.com/oauth/token)",
  "Client ID": "ID del cliente",
  "Client Secret": "Secreto del cliente",
  "OAuth2 will automatically fetch a new access token before each API call.": "OAuth2 obtendrá automáticamente un token de acceso nuevo antes de cada llamada a la API.",
  "Enter credential value (API key, token, etc.)": "Ingresa el valor de la credencial (clave de API, token, etc.)",
  "Create Credential": "Crear credencial",
  "Test Execution History": "Historial de ejecuciones de pruebas",
  "Test:": "Prueba:",
  "Loading execution history...": "Cargando historial de ejecuciones...",
  "No executions found for this test": "No se encontraron ejecuciones de esta prueba",
  "Run the test to see execution history": "Ejecuta la prueba para ver su historial",
  "Select a test to view its execution history": "Selecciona una prueba para ver su historial de ejecuciones",
  "Click the \"History\" button next to any test in the Tests tab": "Haz clic en el botón \"Historial\" de una prueba en la pestaña Pruebas",
  "Edit Environment": "Editar entorno",
  "Update environment variables and settings.": "Actualiza las variables y la configuración del entorno.",
  "Updating...": "Actualizando...",
  "Update Environment": "Actualizar entorno",
  "Edit Credential": "Editar credencial",
  "New Credential Value": "Nuevo valor de la credencial",
  "Enter new credential value (leave empty to keep current)": "Ingresa un valor nuevo (deja vacío para conservar el actual)",
  "Leave empty to keep the current credential value": "Deja vacío para conservar el valor actual de la credencial",
  "Update Credential": "Actualizar credencial",
  "Delete API Test": "Eliminar prueba de API",
  "This action cannot be undone. This will permanently delete the test and all its execution history.": "Esta acción no se puede deshacer. Se eliminarán permanentemente la prueba y todo su historial de ejecuciones.",
  "Are you sure you want to delete this API test?": "¿Seguro que deseas eliminar esta prueba de API?",
  "Deleting...": "Eliminando...",
  "Delete Test": "Eliminar prueba",
  "Delete Schedule": "Eliminar programación",
  "This action cannot be undone. This will permanently delete the schedule.": "Esta acción no se puede deshacer. Se eliminará permanentemente la programación.",
  "Recurring": "Recurrente",
  "Schedule": "Programar",
  "Scheduled for: {v0}": "Programada para: {v0}",
  "Recurring: {v0}": "Recurrente: {v0}",
  "Are you sure you want to delete this schedule?": "¿Seguro que deseas eliminar esta programación?",
  "Delete Environment": "Eliminar entorno",
  "This action cannot be undone. This will permanently delete the environment and all its variables.": "Esta acción no se puede deshacer. Se eliminarán permanentemente el entorno y todas sus variables.",
  "Are you sure you want to delete this environment?": "¿Seguro que deseas eliminar este entorno?",
  "Delete Credential": "Eliminar credencial",
  "This action cannot be undone. This will permanently delete the credential.": "Esta acción no se puede deshacer. Se eliminará permanentemente la credencial.",
  "Type:": "Tipo:",
  "Are you sure you want to delete this credential?": "¿Seguro que deseas eliminar esta credencial?",
  "Expected:": "Valor esperado:",
  "Jira Ticket Created Successfully!": "¡Incidencia de Jira creada correctamente!",
  "Issue {v0} has been created.": "Se ha creado la incidencia {v0}.",
  "View in Jira": "Ver en Jira",
  "{v0} recurring": "Recurrencia {v0}",
  "daily": "diaria",
  "weekly": "semanal",
  "monthly": "mensual",
  "PASS": "APROBADA",
  "FAIL": "FALLIDA",
  "passed": "aprobada",
  "running": "en ejecución",
  "pending": "pendiente",
  "completed": "completada",
  "processing": "procesando",
  "success": "correcto",
  "skipped": "omitida",
  "error": "error",
  "{v0} assertions failed": "Validaciones fallidas: {v0}",
  "Bearer Token": "Token Bearer",
  "API Key": "Clave de API",
  "JWT Token": "Token JWT",
  "OAuth2 Client Credentials": "Credenciales de cliente OAuth2",
  "SKIPPED": "OMITIDA",
  "CONDITION_NOT_MET": "NO SE CUMPLIÓ LA CONDICIÓN",
  "RUNNING": "EN EJECUCIÓN",
  "PENDING": "PENDIENTE",
  "COMPLETED": "COMPLETADA",
  "PROCESSING": "PROCESANDO",
  "SUCCESS": "CORRECTO",
  "FAILED": "FALLIDA",
  "ERROR": "ERROR",
  "{v0} passed, {v1} failed": "{v0} aprobadas, {v1} fallidas",
  "Edit": "Editar",
  "Delete": "Eliminar",
  "Screen ID: {v0} - Use this ID when reporting issues or requesting features for this section": "ID de pantalla: {v0}. Usa este ID al reportar problemas o solicitar funciones para esta sección.",
  "{v0} Assertion Failed": "Validación fallida: {v0}",
  "{v0} Assertions Failed": "Validaciones fallidas: {v0}",
  "{v0} assertion failed": "Validación fallida: {v0}"
};
